import { DotLegalButton, DotLegalDeleteDialog, DotLegalEmptyState } from "@dotlegal/dotlegal-ui-components";
import useProcessingActivityInternalAssessmentTabHooks from "./ProcessingActivityInternalAssessment.hooks";
import { useTranslation } from "../../../../localization/useTranslation";
import ProcessingActivityInternalAssessmentDialog from "./processingActivityInternalAssessmentDialog/ProcessingActivityInternalAssessmentDialog";
import { Box } from "@mui/material";
import InternalAssessmentTable from "../../../../common/components/questionnaireComponents/internalAssessmentTable/InternalAssessmentTable";
import NoSharings from "../../processingActivitySharingsTab/noSharings.svg?react";
import { useUserContext } from "../../../../auth/userContextProvider/UserContextProvider";

export interface IProcessingActivityInternalAssessmentTabProps {
    processingActivityId: string;
    processingActivityName: string;
    onAuditsChanged: () => void;
}

function ProcessingActivityInternalAssessmentTab(props: IProcessingActivityInternalAssessmentTabProps) {
    const { translateString } = useTranslation();
    const { permissions } = useUserContext();
    const {
        showAddDialog,
        setShowAddDialog,
        data,
        isLoading,
        refetch,
        setShowDeleteDialog,
        showDeleteDialog,
        setSelectedInternalAssessment,
        removeAssociatedInternalAssessment,
        isRemoving,
    } = useProcessingActivityInternalAssessmentTabHooks(props);

    return (
        <>
            <InternalAssessmentTable
                internalAssessmentModel={data}
                isLoading={isLoading}
                readOnly
                emptyState={<DotLegalEmptyState icon={<NoSharings />} text={translateString("noAssociatedInternalAssessments")} />}
                getMenuItems={(row) =>
                    permissions.processingActivityPermissions.edit
                        ? [
                              {
                                  menuItem: translateString("removeAssociation"),
                                  onClick: () => {
                                      setSelectedInternalAssessment(row);
                                      setShowDeleteDialog(true);
                                  },
                              },
                          ]
                        : []
                }
                sessionStorageKey={`processing-activity-${props.processingActivityId}-internal-assessments-filters`}
            />

            {permissions.processingActivityPermissions.edit && (
                <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                    <DotLegalButton onClick={() => setShowAddDialog(true)} buttonType={"primary"}>
                        {translateString("associateAssessmentToProcessingActivity")}
                    </DotLegalButton>
                </Box>
            )}

            {showAddDialog && (
                <ProcessingActivityInternalAssessmentDialog
                    processingActivityId={props.processingActivityId}
                    processingActivityName={props.processingActivityName}
                    onDialogClose={() => {
                        refetch();
                        props.onAuditsChanged();
                        setShowAddDialog(false);
                    }}
                    existingInternalAssessments={data ? data?.rows?.map((x) => x.id) : []}
                />
            )}

            {showDeleteDialog && (
                <DotLegalDeleteDialog
                    open
                    headerText={translateString("removeAssociation")}
                    warningTranslation={""}
                    deleteBtnText={translateString("remove")}
                    cancelBtnText={translateString("cancel")}
                    onDialogClose={() => setShowDeleteDialog(false)}
                    onOkClick={() => removeAssociatedInternalAssessment()}
                    alertBodyText={translateString("removeInternalAssessmentToProcessingActivity")}
                    inProgress={isRemoving}
                />
            )}
        </>
    );
}

export default ProcessingActivityInternalAssessmentTab;
